exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-responsive {\n  width: 30px;\n  height: 30px; }\n\n.pointer {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-cap-rank/market-cap-rank.component.scss
// module id = ../../../../../src/app/market-level/market-cap-rank/market-cap-rank.component.scss
// module chunks = main